var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.71240799e-12,0 L1.71240799e-12,0 L4.98560241,0 C6.64129876,0.00237399988 7.9839644,1.07571018 7.98856771,2.40059235 L8.00240544,13.5970348 C8.00403567,14.9228447 6.66221819,15.9986884 5.00537109,16 C5.00273428,16 5.00010381,16 4.99747335,16 L0.0146950381,15.9934496 L0.0146950381,15.9934496",
    id: "Path",
    transform: "translate(4.001203, 8.000000) scale(-1, 1) translate(-4.001203, -8.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(9.997034, 8.000000) scale(-1, 1) translate(-9.997034, -8.000000) translate(3.997034, 4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.500000, 4.000000) scale(-1, 1) translate(-6.500000, -4.000000) translate(1.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -1.36424205e-12,
    y1: 1,
    x2: 11,
    y2: 1,
    id: "Path-18"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    points: "3.49816895 7.5 0.354797363 4 3.49816895 0.5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.c34ac7b391ed49b654466a77e6fd5e70.svg";
export { ForwardRef as ReactComponent };